import type { History } from "history";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

interface HistoryContextType {
  history: History;
}

const Default: HistoryContextType = {
  history: null as unknown as History,
};

const HistoryContext = createContext<HistoryContextType>(Default);

/**
 * @deprecated use APIs from react-router instead, this isn't supported in future versions of react-router
 * @see https://reactrouter.com/home for more information
 */
const useHistory = () => {
  const { history } = useContext(HistoryContext);

  return history;
};

interface Props {
  history: History;
  children: ReactNode;
}

const HistoryProvider = ({ children, history }: Props) => {
  return <HistoryContext value={{ history }}>{children}</HistoryContext>;
};

export { HistoryProvider, useHistory };
export type { HistoryContextType };
